// extracted by mini-css-extract-plugin
export default {"wrapper":"Loader_wrapper__xU85x","message":"Loader_message__wFrvI","title":"Loader_title__Ljg0L","subtitle":"Loader_subtitle__M6snq"};